(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/tab-handler.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/tab-handler.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.behaviors.TabHandler = Marionette.Behavior.extend({
    ui: {
      loginTab: '#loginTab'
    },
    events: {
      'click @ui.loginTab': 'onLoginTabClick'
    },
    onLoginTabClick: function onLoginTabClick(e) {
      var _this = this;

      var logger = svs.core.log.getLogger('module:player-login'),
          previousTab = this.view.model.get('currentTab') || 'bankid';

      if ($(e.target).attr('data-tab') === 'frejaeidTab') {
        this.view.model.set('currentTab', 'frejaeid');
        $('#eid-info').show();
        $('#eid-type').text('Freja eID');

        if (svs.core.detect.formfactor.desktop() && !this.view.model.get('isTabletDevice') && !svs.core.detect.touch()) {
          this.view.model.set('otherFrejaDevice', true);
          this.startFrejaQRCodeLogin();
        } else {
          this.view.model.set('otherFrejaDevice', false);
          this.view.render();
        }
      } else if ($(e.target).attr('data-tab') === 'bankidTab') {
        this.view.model.set('currentTab', 'bankid');
        $('#eid-info').show();
        $('#eid-type').text('BankID');
        this.view.model.set('hideBankIdLogin', false);
      } else if ($(e.target).attr('data-tab') === 'usernameTab') {
        this.view.model.set('currentTab', 'username');
        $('#eid-info').hide();
      } 


      svs.core.deviceSession.set('currentLoginMethod', 'customer_login', this.view.model.get('currentTab'), function (err) {
        if (err) {
          logger.debug('Error when saving current login method to device session.');
        }

        if (previousTab === 'frejaeid') {
          _this.changeFromFrejaEidTab();
        } else {
          _this.changeFromBankIDOtherDeviceTab();
        }
      });
    },
    changeFromFrejaEidTab: function changeFromFrejaEidTab() {
      var _this2 = this;

      var isFrejaPoll = window.location.href.indexOf('logga-in/frejaeidpoll') > -1;

      if (isFrejaPoll && Boolean(this.view.cancelPoll) && Boolean(this.view.abortCustomerLogin)) {
        this.view.abortCustomerLogin();
        this.view.cancelPoll(function () {
          svs.player_login.router.navigate("/?".concat(_this2.view.model.toQueryString()), true);

          _this2.view.render();
        });
      } else {
        this.view.render();
      }
    },
    changeFromBankIDOtherDeviceTab: function changeFromBankIDOtherDeviceTab() {
      var isBankIDOtherDeviceTab = window.location.href.indexOf('logga-in/mobilt-bankid') > -1;

      if (isBankIDOtherDeviceTab) {
        svs.player_login.router.navigate("/?".concat(this.view.model.toQueryString()), true);
      } else {
        this.view.render();
      }
    },
    startFrejaQRCodeLogin: function startFrejaQRCodeLogin() {
      var _this3 = this;

      svs.player_login.radio.request('authRef').done(function (authRef) {
        _this3.view.model.set('authRef', authRef);

        _this3.view.model.set('otherFrejaDevice', true);

        svs.player_login.router.navigate("frejaeidpoll?".concat(_this3.view.model.toQueryString('frejaeid')), true);
      }).fail(function (err) {
        _this3.triggerMethod('frejaEidError', err);
      });
    }
  });
})(Backbone, _, svs);
 })(window);